import { createContext, useCallback, useContext, useEffect, useReducer, useState } from 'react';

const initialState = { 
    settingsOpen: false,
    settingTitle: '',
    settingCode: '',
    currentNotify: null,
    settingData: null,
    sweetDialogInfo: null,
    settingButtonLabel: null,
    isSidebarOpen: true,
    isMobileHeaderOpen: false,
    showSettingButtons: true
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
};


const ThemeContext = createContext();

export const ThemeProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [systemLoading, setSystemLoading] = useState(false);
   const [systemFunction, setSystemFunction] = useState(() => {
    return () => alert("No function assigned");
  });

  useEffect(()=>{
    if(state.currentNotify){
        setTimeout(() => {
            setNotify(null);
        }, 10000);
    }
  }, [state.currentNotify])

  const openSettings = (title, code, data, buttonLabel, showButtons = true) =>{
    dispatch({type: 'settingsOpen', payload: true});
    dispatch({type: 'settingTitle', payload: title});
    dispatch({type: 'settingCode', payload: code});
    dispatch({type: 'settingData', payload: data});
    dispatch({type: 'settingButtonLabel', payload: buttonLabel});
    dispatch({type: 'showSettingButtons', payload: showButtons});
  }
 
  const closeSettings = ()=>{
    dispatch({type: 'settingsOpen', payload: false})
    dispatch({type: 'settingCode', payload: null})
  }

  const setNotify = (notify) =>{
    dispatch({type: 'currentNotify', payload: notify})
  }

  const setSweetDialogInfo = (title, subtitle) =>{
    dispatch({type: 'sweetDialogInfo', payload: {title: title, subtitle: subtitle}})
  }
  const clearSweetDialogInfo = () =>{
    dispatch({type: 'sweetDialogInfo', payload: null})
  }

  const runSystemFunction = useCallback(async () => {
    if (typeof systemFunction === "function") {
      await systemFunction();
    }
  }, [systemFunction]);

  const toggleSidebar = () =>{
    dispatch({type: 'isSidebarOpen', payload: !state.isSidebarOpen})
  }
  const toggleMobileHeader = () =>{
    dispatch({type: 'isMobileHeaderOpen', payload: !state.isMobileHeaderOpen})
  }
  
  return(
    <ThemeContext.Provider value={{
      ...state,
      systemLoading,
      systemFunction,
      setSystemFunction,
      setSystemLoading, 
      dispatch,
      openSettings,
      closeSettings,
      setNotify,
      setSweetDialogInfo,
      clearSweetDialogInfo, 
      runSystemFunction,
      toggleSidebar,
      toggleMobileHeader
      }}>
      {children}
    </ThemeContext.Provider>
  )

}

export const useTheme = ()=>useContext(ThemeContext);

